import React from 'react';
import { Modal } from '@iwoca/orion';
import { t } from '@lingui/macro';
import { ASSET_PREFIX } from 'utils/assets/assets';
import styles from './LoadingModal.module.css';

type Props = {
  heading?: string;
  text?: string;
  showModal: boolean;
};
export const LoadingModal: React.FC<Props> = ({ heading, text, showModal }) => {
  return (
    // TODO remove onClose when Orion makes onClose optional
    <Modal isOpen={showModal} onClose={() => {}}>
      <div className={styles.content}>
        <picture>
          <img
            data-testid="spinner"
            src={`${ASSET_PREFIX}/iwocaLoader.gif`}
            alt={t`loading...`}
            className={styles.spinner}
          />
        </picture>
        {heading && <h2>{heading}</h2>}
        {text && <p>{text}</p>}
      </div>
    </Modal>
  );
};
